/* eslint-disable @typescript-eslint/camelcase */
import Vue from 'vue';
import { ValidationProvider, extend } from 'vee-validate';
import {
  required, email, confirmed, numeric, max, min, size, ext, max_value,
} from 'vee-validate/dist/rules';
import validator from 'validator';

extend('confirmed', {
  ...confirmed,
  message: "{_field_} doesn't match",
});

extend('max', {
  ...max,
  message: '{_field_} max 16 character',
});

extend('max_value', {
  ...max_value,
  message: '{_field_} max value is {max}',
});

extend('min', {
  ...min,
  message: '{_field_} min 6 character',
});

extend('email', {
  ...email,
  message: 'Please input email correctly. Email address must contain a “@“ sign and a period (.)',
});

extend('required', {
  ...required,
  message: '{_field_} must be filled',
});

extend('numeric', {
  ...numeric,
  message: '{_field_} must be filled with only numbers',
});

extend('size', {
  ...size,
  message: '{_field_} must be less than 3MB',
});

extend('ext', {
  ...ext,
  message: 'Invalid file format',
});

extend('password', {
  validate: (value) => {
    const rule = /(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
    return rule.test(value);
  },
  message: 'Password must contain at least 8 characters, alphanumeric, and upper and lower case',
});

extend('new-password', {
  params: ['target'],
  validate(value, params) {
    const { target } = params as { target: string };
    return value !== target;
  },
  message: 'New password cannot be the same as your current password',
});

extend('urlhttps', {
  // eslint-disable-next-line @typescript-eslint/camelcase
  validate: (value) => validator.isURL(value, { protocols: ['https', 'http'], require_protocol: true }),
  message: 'URL must be a valid url with https:// or http://',
});

extend('url', {
  validate(value: string | null | undefined): boolean {
    if (value) {
      // eslint-disable-next-line max-len
      return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value);
    }

    return false;
  },
  message: 'This value must be a valid URL',
});

extend('percentage', {
  // eslint-disable-next-line @typescript-eslint/camelcase
  validate: (value) => value >= 0 && value <= 100,
  message: '{_field_} must be between 0 and 100',
});

Vue.component('validation-provider', ValidationProvider);
